import React from "react";
import { useLanguage } from "../../hooks/useLanguage";
import { motion } from "framer-motion";
import { Clock } from "lucide-react";

export default function OpeningHoursBar() {
  const { t, language } = useLanguage();

  // Opening hours in a simplified format
  // const openingHours =
  //   language === "en"
  //     ? "Mon-Sat: 10:30  - 21:00  | Sun: 12:00  - 21:00 "
  //     : "Ma-La: 10:30 - 21:00 | Su: 12:00 - 21:00";
      
  // Lunch hours information
  const lunchHours =
    language === "en"
      ? "Lunch: Mon-Fri 10:30 - 14:30"
      : "Lounas: Ma-Pe 10:30 - 14:30";

  return (
    <motion.div
      initial={{ height: 0, opacity: 0 }}
      animate={{ height: "auto", opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="bg-gradient-to-r from-primary/90 to-secondary/90 text-white text-sm overflow-hidden"
    >
      <div className="container mx-auto px-4 py-2">
        <div className="flex flex-col items-center justify-center">
          {/* <div className="flex items-center justify-center space-x-2">
            <Clock size={16} className="text-white opacity-90" />
            <p className="text-center font-medium">{openingHours}</p>
          </div> */}
          <div className="flex items-center justify-center space-x-2 mt-1">
            <p className="text-center font-medium text-amber-200">{lunchHours}</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
